module.exports = __webpack_public_path__ + "static/media/snm-masala.4e001387.png";